import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    title: 'Ready to Transform Your Kitchen?',
    subtitle: 'Join thousands of home cooks discovering new recipes with AI',
    description: 'Stop wondering what to cook. Let AI create your perfect recipe from what you have.',
    cta: 'Start Cooking Now'
  },
  sl: {
    title: 'Pripravljeni na preobrazbo vaše kuhinje?',
    subtitle: 'Pridružite se tisočem domačih kuharjev, ki odkrivajo nove recepte z umetno inteligenco',
    description: 'Prenehajte se spraševati, kaj kuhati. Pustite, da umetna inteligenca ustvari vaš popoln recept iz tega, kar imate.',
    cta: 'Začnite kuhati zdaj'
  }
};

const CTA = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="py-20 px-4 bg-gradient-green">
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
          {t.title}
        </h2>
        <p className="text-xl text-white/90 mb-4" style={{ fontFamily: 'Lato, sans-serif' }}>
          {t.subtitle}
        </p>
        <p className="text-lg text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          {t.description}
        </p>
        <div className="text-center">
          <a 
            href="/start"
            className="inline-block px-10 py-5 bg-white text-primary rounded-lg text-xl font-semibold hover:opacity-90 transition shadow-lg"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            {t.cta} →
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTA;
